import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import { isNullOrEmpty } from '../../../../../utils/vuex';
import get from 'lodash/get';
export default {
  name: 'CoreDtwinStateBridgeOpenweather',
  props: {
    // the current edited binding
    lclModel: {
      type: Object,
      required: true
    },
    bridgeConfig: {
      type: Object,
      required: true
    },
    mode: {
      type: String,
      required: false,
      default: function _default() {
        return 'edit';
      }
    }
  },
  data: function data() {
    return {
      deviceIdentifier: null,
      parsedPacketVariable: null,
      selectedWeatherVariable: [],
      variableTableHeader: [{
        sortable: true,
        text: 'Name',
        value: 'variable',
        align: 'left'
      }, {
        sortable: true,
        text: this.$i18n_t('Common.description'),
        value: 'description',
        align: 'left'
      }, {
        sortable: true,
        text: this.$i18n_t('DigitalTwin.DigitalTwin.states.unit'),
        value: 'value_type_name',
        align: 'left'
      }]
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme'])), {}, {
    formIsValid: function formIsValid() {
      return !isNullOrEmpty(this.deviceIdentifier);
    },
    weatherVariables: function weatherVariables() {
      var _this = this;

      var _variables = [{
        variable: 'cur_temperature',
        keyName: 'current',
        descrKey: 'temperature',
        unit: '°C'
      }, {
        variable: 'cur_temperature_feels_like',
        keyName: 'current',
        descrKey: 'temperature_feels_like',
        unit: '°C'
      }, {
        variable: 'cur_pressure',
        keyName: 'current',
        descrKey: 'pressure',
        unit: 'hPa'
      }, {
        variable: 'cur_humidity',
        keyName: 'current',
        descrKey: 'humidity',
        unit: '%'
      }, {
        variable: 'cur_wind_speed',
        keyName: 'current',
        descrKey: 'wind_speed',
        unit: ''
      }, {
        variable: 'cur_wind_direction',
        keyName: 'current',
        descrKey: 'wind_direction',
        unit: '°'
      }, {
        variable: 'cur_uv_index',
        keyName: 'current',
        descrKey: 'uv_index',
        unit: ''
      }, {
        variable: 'cur_clouds_pct',
        keyName: 'current',
        descrKey: 'clouds_pct',
        unit: '%'
      }];

      for (var day = 0; day < 7; day++) {
        var keyName = day === 0 ? 'today' : "plus_".concat(day);
        _variables = _variables.concat([{
          variable: "".concat(keyName, "_temp_day"),
          keyName: keyName,
          descrKey: 'temperature_day',
          unit: '°C'
        }, {
          variable: "".concat(keyName, "_temp_night"),
          keyName: keyName,
          descrKey: 'temperature_night',
          unit: '°C'
        }, {
          variable: "".concat(keyName, "_temp_min"),
          keyName: keyName,
          descrKey: 'temperature_min',
          unit: '°C'
        }, {
          variable: "".concat(keyName, "_temp_max"),
          keyName: keyName,
          descrKey: 'temperature_max',
          unit: '°C'
        }, {
          variable: "".concat(keyName, "_pressure"),
          keyName: keyName,
          descrKey: 'pressure',
          unit: 'hPa'
        }, {
          variable: "".concat(keyName, "_humidity"),
          keyName: keyName,
          descrKey: 'humidity',
          unit: '%'
        }, {
          variable: "".concat(keyName, "_wind_speed"),
          keyName: keyName,
          descrKey: 'wind_speed',
          unit: ''
        }, {
          variable: "".concat(keyName, "_wind_direction"),
          keyName: keyName,
          descrKey: 'wind_direction',
          unit: '°'
        }, {
          variable: "".concat(keyName, "_rain_mm"),
          keyName: keyName,
          descrKey: 'rain_mm',
          unit: 'mm'
        }, {
          variable: "".concat(keyName, "_uv_index"),
          keyName: keyName,
          descrKey: 'uv_index',
          unit: ''
        }, {
          variable: "".concat(keyName, "_clouds_pct"),
          keyName: keyName,
          descrKey: 'clouds_pct',
          unit: '%'
        }]);
      }

      return _variables.map(function (wVar) {
        var day = _this.$i18n_t("Bridges.Openweather.".concat(wVar.keyName));

        var desc = _this.$i18n_t("Bridges.Openweather.".concat(wVar.descrKey));

        return {
          variable: wVar.variable,
          description: "".concat(day, " - ").concat(desc),
          value_type_name: wVar.unit
        };
      });
    }
  }),
  watch: {
    parsedPacketVariable: function parsedPacketVariable() {
      this.emitSelection();
    },
    deviceIdentifier: function deviceIdentifier() {
      this.emitSelection();
    }
  },
  created: function created() {
    if (this.bridgeConfig.stationId) {
      this.deviceIdentifier = this.bridgeConfig.stationId;
    } else {
      this.deviceIdentifier = this.bridgeConfig.configId;
    }

    this.selectedWeatherVariable = [{
      variable: this.lclModel.properties.binding.options.variable
    }];
  },
  methods: {
    emitSelection: function emitSelection() {
      this.$emit('bridge-binding-changed', {
        valueType: get(this.selectedWeatherVariable, '[0].value_type_name'),
        variable: get(this.selectedWeatherVariable, '[0].variable')
      });
    },
    saveState: function saveState() {
      this.lclModel.properties.binding.options.identifier = this.deviceIdentifier;
      this.lclModel.properties.binding.options.variable = this.selectedWeatherVariable[0].variable;
    }
  }
};